import app from './app';
import { filterLegalEntities } from '../../utils/utility';
import { QUOTE_DEAL_SERVICE_URL, CUSTOMERENTITY_SERVICE_URL, CATALOG_SERVICE_URL, QUOTE_SERVICE_URL, CHECK_QUOTE_DEAL_SERVICE_URL, DEAL_SERVICE_URL } from '../../libs/constants';

const getUserSpecificDeals = (userId, requestData) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getDealList" } };
        const response = await api.post(QUOTE_DEAL_SERVICE_URL + '/list/' + userId, requestData, headerConfig);

        dispatch(app.setLoading(false));
        dispatch({ type: "SET_USER_SPECIFIC_DEALS", data: response.data });
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const markDealAsCompleted = (dealId) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "markDealAsCompleted" } };
        await api.post(QUOTE_DEAL_SERVICE_URL + '/markCompleted/' + dealId, {}, headerConfig);

        dispatch(app.setLoading(false));
    } catch (error) {
        console.log(error);
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const getDealDetails = (dealId) => async (dispatch, getState, api) => {
    try {
        const headerConfig = { headers: { "DRS-Fetch-Type": "getDealDetails" } };
        const response = await api.post(QUOTE_DEAL_SERVICE_URL + '/' + dealId, {}, headerConfig);
        const dealDetails = response.data;
        dealDetails.ctInitialQuote = dealDetails.ctInitialQuote ? dealDetails.ctInitialQuote.split(',') : [];
        dispatch({ type: "SET_DEAL_DETAILS", data: dealDetails });
    } catch (error) {
        console.log(error);
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const setFormDirty = (value) => {
    return {
        type: "SET_FORM_DIRTY",
        data: value
    }
}

const createDeal = (requestData = {}) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    const headerConfig = { headers: { "DRS-Fetch-Type": "createNewDeal" } };

    await api.post(QUOTE_DEAL_SERVICE_URL, requestData, headerConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            dispatch(setFormDirty(false));
            dispatch(setFormInvalid(false));
            dispatch({ type: "SET_DEAL_CREATION_STATUS", data: "SUCCESS" });
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            const errorData = error.response && error.response.data ? error.response.data : {};
            const { errorCode, message } = errorData;

            if (errorCode === 500 && message === 'ALREADY_EXISTS') {
                dispatch(app.setAppModal({ type: "error", messageId: "deal_exists_for_date" }));
                dispatch({ type: "SET_DEAL_CREATION_STATUS", data: "ERROR" });
            }
            else if (errorCode === 500 && message === 'ALREADY_ACTIVE_DEAL') {
                dispatch(app.setAppModal({ type: "error", messageId: "activeDealExist" }));
                dispatch({ type: "SET_DEAL_CREATION_STATUS", data: "ERROR" });
            }
            else {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
                dispatch({ type: "SET_DEAL_CREATION_STATUS", data: "ERROR" });
            }
        });
};

const updateDealCurrencyAndVendor = (dealId, userId, requestData) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));

    await api.post(`/quote${DEAL_SERVICE_URL}/update/${dealId}/${userId}`, requestData, {})
        .then(response => {
            dispatch(app.setLoading(false));
            dispatch(getDealDetails(dealId));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const checkDuplicateDeal = (requestData = {}) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    const headerConfig = { headers: { "DRS-Fetch-Type": "createNewDeal" } };

    await api.post(CHECK_QUOTE_DEAL_SERVICE_URL, requestData, headerConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            dispatch(setFormDirty(false));
            dispatch(setFormInvalid(false));
            dispatch({ type: "SET_DEAL_OVERLAP_STATUS", data: response.data });
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            const errorData = error.response && error.response.data ? error.response.data : {};
            const { errorCode, message } = errorData;

            if (errorCode === 500 && message === 'ALREADY_EXISTS') {
                dispatch(app.setAppModal({ type: "error", messageId: "deal_exists_for_date" }));
                dispatch({ type: "SET_DEAL_OVERLAP_STATUS", data: "ERROR" });
            }
            else if (errorCode === 500 && message === 'ALREADY_ACTIVE_DEAL') {
                dispatch(app.setAppModal({ type: "error", messageId: "activeDealExist" }));
                dispatch({ type: "SET_DEAL_OVERLAP_STATUS", data: "ERROR" });
            }
            else {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
                dispatch({ type: "SET_DEAL_OVERLAP_STATUS", data: "ERROR" });
            }
        });
};

const dealOverlapStatusReset = () => async (dispatch) => {
    dispatch({ type: "SET_DEAL_OVERLAP_STATUS", data: "" });
};

const getAllCustomerEntity = (userId, requestData) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getCustomerEntities" } };
        const response = await api.post(`${CUSTOMERENTITY_SERVICE_URL}/getCustomerEntities/${userId}`, requestData, headerConfig);

        dispatch(app.setLoading(false));
        dispatch({ type: "SET_CUSTOMER_ENTITY_LIST", data: response.data.customerList });
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const getCustomerServiceRateCard = (orgId) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getCustomerServiceRateCard" } };
        const response = await api.post(`${CATALOG_SERVICE_URL}priceList/directPriceList/${orgId}`, {}, headerConfig);
        const directPriceList = response.data.priceListDirectCustomerResponse.map(list => {
            return { priceList: list.priceList, countryCode: list.countryCode }
        });

        dispatch(app.setLoading(false));
        dispatch({ type: "SET_CUSTOMER_SERVICE_RATECARD_LIST", data: directPriceList });
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const getCTInitialForQuotesDealType = (userId, companyName, dealType, orgId) => async (dispatch, getState, api) => {
    try {

        const headerConfig = { headers: { "DRS-Fetch-Type": "fetchCTquotes" } };
        const response = await api.post(`${QUOTE_SERVICE_URL}/deal/fetchCTquotes/${userId}/${companyName}/${dealType}/${orgId}`, {}, headerConfig);
        const quotes = [...response.data]
        dispatch({ type: "SET_CT_INITIAL_QUOTE_LIST", data: quotes });
    } catch (error) {
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const getCTInitialQuoteDetailList = (userId, quoteList, orgId, company) => async (dispatch, getState, api) => {
    try {

        const headerConfig = { headers: { "DRS-Fetch-Type": "fetchCTquoteDetailList" } };
        const response = await api.post(`${QUOTE_SERVICE_URL}/fetchCTQuoteDetailsForDirectCustomer/${userId}/${orgId}/${company}`, quoteList, headerConfig);
        const quoteDetailList = [...response.data]

        dispatch({ type: "SET_CT_INITIAL_QUOTE_DETAIL_LIST", data: quoteDetailList });
        dispatch(isRefreshCountryMapping(true))
    } catch (error) {
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const saveCTQuoteDetails = (requestData = {}) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        await api.post(`${QUOTE_SERVICE_URL}/directCustomer/createAutoQuote`, requestData, {});
        dispatch(app.setLoading(false));
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
}

const resetCTInitialForQuotesDealType = () => async (dispatch) => {
    dispatch({ type: "RESET_CT_INITIAL_QUOTE_LIST", data: [] });
}

const resetCTInitialQuoteDetailList = () => async (dispatch) => {
    dispatch({ type: "RESET_CT_INITIAL_QUOTE_DETAIL_LIST", data: [] });
}

const getCustomerEntityDetails = (userId, orgId, list, listType) => async (dispatch, getState, api) => {
    try {
        const headerConfig = { headers: { "DRS-Fetch-Type": "getCustomerLegalEntities" } };
        const response = await api.post(`${CUSTOMERENTITY_SERVICE_URL}/getCustomerLegalEntities/${userId}/${orgId}`, {}, headerConfig);

        const legalEntityList = list.length ? filterLegalEntities(list, response.data.legalEntityList, listType) : [];

        dispatch({ type: "SET_LEGAL_ENTITY_DETAILS", data: legalEntityList });
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const setDealDetailsData = (dealDetails) => {
    return {
        type: 'SET_DEAL_DETAILS_DATA',
        dealDetails
    }
};

const addCountryMappingRow = (defaultCountryMapingRow) => {
    return {
        type: 'ADD_COUNTRY_MAPPING_ROW',
        defaultCountryMapingRow
    }
};

const autoSetCountryMappingList = (countryMappingList) => {
    return {
        type: 'AUTO_SET_COUNTRY_MAPPING_LIST',
        countryMappingList
    }
}

const addAssetTypeRowsForNewCountry = (defaultCountryAssetRowContent) => {
    return {
        type: 'ADD_ASSET_TYPE_ROWS_FOR_NEW_COUNTRY',
        defaultCountryAssetRowContent
    }
};

const setCountryMappingCoulmnValue = (columnName, columnValue, rowIndex) => {
    return {
        type: 'SET_COUNTRY_MAPPING_COLUMN_VALUE',
        columnName,
        columnValue,
        rowIndex
    }
};

const resetCountryMapping = () => {
    return {
        type: 'RESET_COUNTRY_MAPPING',
        countryMappingList: []
    }
}

const setCountryAssetCoulmnValue = (columnName, columnValue, rowIndex) => {
    return {
        type: 'SET_COUNTRY_ASSET_COLUMN_VALUE',
        columnName,
        columnValue,
        rowIndex
    }
};

const resetCountryMappingFieldsSpecificToRow = (rowIndex, defaultCountryMapingRow) => {
    return {
        type: 'RESET_COUNTRY_MAPPING_FIELDS_SPECIFIC_TO_ROW',
        rowIndex,
        defaultCountryMapingRow
    }
};

const resetDealDetails = () => {
    return { type: 'RESET_DEAL_DETAILS_DATA' };
};

const prevQuoteSelection = (ctQuotes) => {
    return { type: 'PREV_QUOTE_SELECTION', data: [...ctQuotes] };
}

const updateCountryCodeOfAllRelatedAssets = (previouslySelectedCountry, newlySelectedCountry, getSelectedMargin) => {
    return {
        type: 'UPDATE_COUNTRY_CODE_OF_ALL_RELATED_ASSETS',
        previouslySelectedCountry,
        newlySelectedCountry,
        getSelectedMargin
    }
};

const deleteSpecificCountryAndPaymentMapping = (countryCode) => {
    return {
        type: 'DELETE_SPECIFC_COUNTRY_AND_PAYMENT_MAPPING',
        countryCode
    }
};

const deleteSpecificCountryAndAssetMapping = (countryCode) => {
    return {
        type: 'DELETE_SPECIFC_COUNTRY_AND_ASSET_MAPPING',
        countryCode
    }
};
const setFormInvalid = (formInValid) => {
    return {
        type: 'SET_FORM_INVALID',
        data: formInValid
    }
};
const updateLegalEntityColumnValue = (value, columnName, legalEntityId) => {
    return {
        type: "UPDATE_LEGALENTITY_COLUMN_VALUE",
        value,
        columnName,
        legalEntityId
    }
};

const updateCTQuoteDetailsColumnValue = (value, columnName, quoteId, index) => {
    return {
        type: "UPDATE_CT_QUOTE_DETAILS_COLUMN_VALUE",
        value,
        columnName,
        quoteId,
        index
    }
};

const setCTInitialQuoteListInDealDetails = (quoteList) => {
    return {
        type: "SET_CT_INITIAL_QUOTE_LIST_FOR_DEAL_DETAILS",
        data: quoteList
    }
}

const isRefreshCountryMapping = (value) => {
    return {
        type: "IS_REFRESH_COUNTRY_MAPPING",
        data: value
    }
}

const resetCountrySpecificMarginList = (marginList) => {
    return {
        type: "RESET_COUNTRY_SPECIFIC_MARGIN_LIST",
        data: []
    }
}

export default {
    getUserSpecificDeals,
    markDealAsCompleted,
    getDealDetails,
    setDealDetailsData,
    addCountryMappingRow,
    autoSetCountryMappingList,
    setCountryMappingCoulmnValue,
    resetCountryMapping,
    resetDealDetails,
    createDeal,
    updateDealCurrencyAndVendor,
    checkDuplicateDeal,
    addAssetTypeRowsForNewCountry,
    setCountryAssetCoulmnValue,
    updateCountryCodeOfAllRelatedAssets,
    deleteSpecificCountryAndAssetMapping,
    resetCountryMappingFieldsSpecificToRow,
    deleteSpecificCountryAndPaymentMapping,
    setFormDirty,
    getAllCustomerEntity,
    getCustomerServiceRateCard,
    getCTInitialForQuotesDealType,
    getCTInitialQuoteDetailList,
    saveCTQuoteDetails,
    resetCTInitialForQuotesDealType,
    resetCTInitialQuoteDetailList,
    getCustomerEntityDetails,
    updateLegalEntityColumnValue,
    updateCTQuoteDetailsColumnValue,
    setFormInvalid,
    dealOverlapStatusReset,
    prevQuoteSelection,
    setCTInitialQuoteListInDealDetails,
    isRefreshCountryMapping,
    resetCountrySpecificMarginList
}